export const formErrorAlertSx = {
  width: '100%',
  alignItems: 'center',
  '& .MuiAlert-message': { width: '100%', textAlign: 'left' },
} as const;
